module.exports = __webpack_public_path__ + "media/Ambient.3797d88e.mp3";